// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__7uoVc","author":"Table_author__s__h7","authorImage":"Table_authorImage__3Qqh-","unreadRow":"Table_unreadRow__2SYE2"};